/**
 * Race graph colours. The four mark colours (winner, head start, penalty,
 * early) were checked as a set with the dataviz palette validator against a
 * white surface: lightness band, chroma floor, colour-blind separation and
 * 3:1 contrast all pass. Text never wears them; it stays in the ink tokens.
 */
export const COLORS = {
  winner: '#9333ea',
  winnerWash: '#f3e8ff',
  winnerInk: '#6b21a8',
  winnerGuide: '#e2d1fb',
  headStart: '#0d9488',
  penalty: '#d97706',
  early: '#e11d48',
  earlyWash: '#ffe4e6',
  earlyInk: '#be123c',
  dot: '#6b7280',
  ink: '#1f2937',
  ink2: '#4b5563',
  muted: '#6b7280',
  label: '#9ca3af',
  grid: '#eeeef2',
  unlock: '#c3c7cf',
  // Translucent so the row hover and open tints show through it.
  tailBand: 'rgba(17, 24, 39, 0.035)',
  surface: '#ffffff',
  border: '#e5e7eb',
  rowHover: '#f8f5fd',
  rowOpen: '#f3eefc',
  cardBg: '#fbfaff',
  cardBorder: '#ebe6f5',
  focus: '#9333ea',
} as const;
